import React, { useEffect, useState } from 'react';
import './SubheaderInPageLinks.scss';
import { useSelector } from 'react-redux';

function SubheaderInPageLinks(props) {
    const isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);
    var activeID = useState(0);
    
    return (
        <div
            className={`subheader-in-page-links area-subheader${isTouchScreen ? " touchscreen" : ""}`}
            ref={props.areaLinkContainer}
        >
            <a href="#overview">Overview</a>
            <a href="#trails">Trails</a>
            <a href="#area">Area</a>
            <a href="#amenities">Amenities</a>
        </div>
    );
}

export default SubheaderInPageLinks;
